<template>
  <div class="smartloc">
    <el-divider content-position="left">模式配置</el-divider>
    <el-table :data="modeData" style="width: 100%;">
      <el-table-column label="已启用" prop="enabled">
        <template slot-scope="scope">
          {{ scope.row.enabled == '1' ? '√' : 'x' }}
        </template>
      </el-table-column>
      <el-table-column label="上行设备" prop="uplink">
      </el-table-column>
      <el-table-column label="下行设备" prop="downlink">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="modeEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-divider content-position="left">连接配置</el-divider>
    <el-table :data="connData" style="width: 100%">
      <el-table-column label="已启用" prop="enabled">
        <template slot-scope="scope">
          {{ scope.row.enabled == '1' ? '√' : 'x' }}
        </template>
      </el-table-column>
      <el-table-column label="名字" prop="name">
      </el-table-column>
      <el-table-column label="工作模式" prop="mode">
      </el-table-column>
      <el-table-column label="目标地址">
        <template slot-scope="scope">
          {{ scope.row.mode == 'LOC Server' ? scope.row.gps_device : scope.row.listen_port }}
        </template>
      </el-table-column>
      <el-table-column label="工作模式" prop="status">
        <template slot-scope="scope">
          <span v-if="!scope.row.enabled">{{ $t('lang.smartlink.disconnect') }}</span>
          <span v-else-if="scope.row.status == 'connected'">{{ $t('lang.smartlink.connected') }}</span>
          <span v-else-if="scope.row.status == 'listening'">{{ $t('lang.smartlink.listening') }}</span>
          <span v-else-if="scope.row.status == 'partial connected'">{{ $t('lang.smartlink.partialConnected')
          }}</span>
          <span v-else>{{ $t('lang.smartlink.unknown')
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="连接数" prop="conn_num">
      </el-table-column>
      <el-table-column label="协议" prop="proto">
      </el-table-column>
      <el-table-column label="操作" width="160px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="connEdit(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleteConn(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="width: 100%;margin-top: 10px;">
      <el-button type="primary" size="mini" @click="addConn">添加</el-button>
    </div>
    <el-divider content-position="left">串口配置</el-divider>
    <el-table :data="comData" style="width: 100%">
      <el-table-column label="接口" prop="interface">
      </el-table-column>
      <el-table-column label="波特率" prop="baudrate">
      </el-table-column>
      <el-table-column label="数据位" prop="stop_bits">
      </el-table-column>
      <el-table-column label="停止位" prop="stop_bits">
      </el-table-column>
      <el-table-column label="校验位" prop="parity">
      </el-table-column>
      <el-table-column label="流控" prop="flow_ctrl">
      </el-table-column>
      <!-- 操作 -->
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="editComDialog(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="编辑" :visible.sync="modeDialog" width="40%" :before-close="handleClose"
      :close-on-click-modal="false">
      <el-form ref="modeForm" :model="modeFormData" label-width="80px">
        <el-form-item label="已启用">
          <el-checkbox v-model="modeFormData.enabled"></el-checkbox>
        </el-form-item>
        <el-form-item label="上行设备">
          <ListValue v-model="modeFormData.uplink" type="select" :options="modeUplinkList" custom size="mini">
          </ListValue>
        </el-form-item>
        <el-form-item label="下行设备">
          <ListValue v-model="modeFormData.downlink" type="select" :options="modeDownlinkList" custom size="mini">
          </ListValue>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="modeConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="connDialog" width="40%" :before-close="handleCloseConnDialog"
      :close-on-click-modal="false">
      <el-form ref="connForm" :model="connFormData" v-loading="connLoading" label-width="120px">
        <el-form-item label="已启用">
          <el-checkbox v-model="connFormData.enabled" size="mini"></el-checkbox>
        </el-form-item>
        <el-form-item label="名字">
          <el-input v-model="connFormData.name" size="mini"></el-input>
        </el-form-item>
        <!-- 工作模式 -->
        <el-form-item label="工作模式" v-if="connFormData.mode == 'LOC Server'">
          <el-select v-model="connFormData.mode" placeholder="请选择" size="mini">
            <el-option label="定位服务" value="LOC Server"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工作模式" v-else>
          <el-select v-model="connFormData.mode" placeholder="请选择" size="mini">
            <el-option v-for="item in workMode" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 监听端口 -->
        <el-form-item label="监听端口" v-if="showServer.includes(connFormData.mode)">
          <el-input v-model="connFormData.listen_port" size="mini"></el-input>
        </el-form-item>
        <!-- 服务器地址 -->
        <el-form-item label="服务器地址" v-if="showClient.includes(connFormData.mode)">
          <ListValue v-model="connFormData.server" type="input" custom size="mini"></ListValue>
        </el-form-item>
        <!-- 协议 -->
        <el-form-item label="协议">
          <el-select v-model="connFormData.proto" placeholder="请选择" size="mini">
            <el-option v-for="item in protoOptions" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- mqtt -->
        <template v-if="connFormData.mode === 'MQTT Client'">
          <el-form-item label="用户名">
            <el-input v-model="connFormData.username" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="connFormData.password" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="订阅主题">
            <el-input v-model="connFormData.topic_sub" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="发布主题">
            <el-input v-model="connFormData.topic_pub" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="Qos">
            <el-select v-model="connFormData.mqtt_qos" placeholder="请选择" size="mini">
              <el-option label="0" value="0"></el-option>
              <el-option label="1" value="1"></el-option>
              <el-option label="2" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户ID">
            <el-input v-model="connFormData.mqtt_cid" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="MQTT保活周期">
            <el-input v-model="connFormData.mqtt_alive" size="mini"></el-input>
          </el-form-item>
        </template>
        <!-- 启用心跳 -->
        <template v-if="connFormData.mode != 'UART'">
          <el-form-item label="启用心跳">
            <el-checkbox v-model="connFormData.enable_hbt" size="mini"></el-checkbox>
          </el-form-item>
          <el-form-item label="心跳间隔" v-if="connFormData.enable_hbt">
            <el-input v-model="connFormData.hbt_interval" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="心跳内容" v-if="connFormData.enable_hbt">
            <el-input v-model="connFormData.hbt_data" size="mini"></el-input>
          </el-form-item>
        </template>
        <!-- 产品ID -->
        <el-form-item label="产品ID">
          <el-input v-model="connFormData.loc_dev_id" size="mini"></el-input>
        </el-form-item>
        <!-- 设备名称 -->
        <el-form-item label="设备名称" v-if="connFormData.mode == 'UART'">
          <el-select v-model="connFormData.loc_dev_name" size="mini">
            <el-option v-for="item in comData" :label="item.interface" :value="item.interface"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="connConfirm">保存并应用</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('lang.Button.edit')" :visible.sync="comDialogVisible" width="50%"
      :before-close="handleCloseComDialog">
      <el-form label-width="170px">
        <el-form-item :label="`${$t('lang.smartlink.baudRate')}：`">
          <el-select size="small" v-model="comForm.baudrate" clearable class="Form-Input-Width">
            <el-option v-for="(item, index) in BaudRateList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('lang.smartlink.dataBits')}：`">
          <el-select allow-create filterable default-first-option size="small" v-model="comForm.data_bits" clearable
            class="Form-Input-Width">
            <el-option v-for="(item, index) in DataBitList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('lang.smartlink.stopBits')}：`">
          <el-select size="small" filterable allow-create default-first-option v-model="comForm.stop_bits" clearable
            class="Form-Input-Width">
            <el-option v-for="(item, index) in StopBitList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('lang.smartlink.checkBits')}：`">
          <el-select size="small" v-model="comForm.parity" clearable class="Form-Input-Width">
            <el-option v-for="(item, index) in CheckDigitList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('lang.smartlink.flowControl')}：`">
          <el-select size="small" v-model="comForm.flow_ctrl" clearable class="Form-Input-Width">
            <el-option v-for="(item, index) in FlowControlList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('lang.smartlink.enableSubcontracting')}：`">
          <el-checkbox v-model="comForm.enable_frame"></el-checkbox>
        </el-form-item>
        <el-form-item :label="`${$t('lang.smartlink.subcontractingInterval')}：`">
          <el-input size="small" v-model="comForm.timeout" clearable class="Form-Input-Width"></el-input>
          <span class="com_Tips">{{ $t('lang.smartlink.subcontractingIntervalTips') }}</span>
        </el-form-item>
        <el-form-item :label="`${$t('lang.smartlink.subcontractingLength')}：`">
          <el-input size="small" v-model="comForm.frame_len" clearable class="Form-Input-Width"></el-input>
          <span class="com_Tips">{{ $t('lang.smartlink.subcontractingLengthTips') }}</span>
        </el-form-item>
      </el-form>
      <el-button type="danger" size="mini" class="Config-Buttom" @click="updateCom">
        {{ $t('lang.ConfigSetting.SaveApply') }}
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import ListValue from '@/views/resource//components/ListValue.vue';
import { updateConfig, } from "@/api/configurationlist";
import { BaudRateList, DataBitList, StopBitList, CheckDigitList, FlowControlList } from '@/utils/com.js'
export default {
  name: "",
  props: ['conn', 'mode', 'serial', "deviceDid", "deviceSn"],
  data() {
    return {
      connData: [],
      modeData: [],
      comData: [],
      modeDialog: false,
      modeForm: null,
      modeFormData: {
        enabled: false,
        uplink: [""],
        downlink: [""]
      },
      modeUplinkList: [

      ],
      modeDownlinkList: [

      ],
      connDialog: false,
      connLoading: false,
      connForm: null,
      connFormData: {
        enabled: false,
        name: "",
        mode: "TCP Server",
        loc_mode: "",
        interval: "",
        realtime_forward: "",
        listen_port: "",
        server: [""],
        loc_dev_id: "",
        username: "",
        password: "",
        topic_sub: "",
        topic_pub: "",
        mqtt_qos: "0",
        mqtt_cid: "",
        mqtt_alive: "",
        enable_hbt: "",
        hbt_interval: "",
        hbt_data: "",
        proto: "LOC NMEA",
        index: 0,
        sname: undefined,
      },
      workMode: [
        {
          value: 'TCP Server',
          label: 'TCP 服务端'
        },
        {
          value: 'TCP Client',
          label: 'TCP 客户端'
        },
        {
          value: 'UDP Server',
          label: 'UDP 服务端'
        },
        {
          value: 'UDP Client',
          label: 'UDP 客户端'
        },
        {
          value: 'UART',
          label: '通用串口'
        },
        {
          value: 'MQTT Client',
          label: 'MQTT 客户端'
        },
      ],
      protoOptions: [
        {
          value: 'LOC NMEA',
          label: 'LOC NMEA'
        },
        {
          value: 'LOC M2M',
          label: 'LOC CIOT'
        },
        {
          value: 'LOC HDS',
          label: 'LOC HDS'
        },
        {
          value: 'LOC LBS',
          label: 'LOC LBS'
        },
        {
          value: 'LOC LBS ALIYU',
          label: 'LOC LBS ALIYU'
        },
      ],
      showServer: [
        'UDP Server',
        'TCP Server',
      ],
      showClient: [
        'UDP Client',
        'TCP Client',
        'MQTT Client'
      ],
      comForm: {
        section: '',
        baudrate: '',
        data_bits: '',
        stop_bits: '',
        parity: '',
        flow_ctrl: '',
        enable_frame: '',
        timeout: '',
        frame_len: '',
        index: '',
      },
      comDialogVisible: false,
      BaudRateList, //波特率选项
      DataBitList, //数据位选项
      StopBitList,  //停止位选项
      CheckDigitList, //校验位选项
      FlowControlList, //流控选项
    };
  },
  methods: {
    modeEdit(row) {
      this.modeDialog = true;
      this.modeFormData.enabled = row.enabled;
      this.modeFormData.uplink = row.uplink;
      this.modeFormData.downlink = row.downlink;
    },
    handleClose() {
      this.modeDialog = false;
    },
    handleCloseConnDialog() {
      this.connDialog = false;
      this.connFormData = {
        enabled: false,
        name: "",
        mode: "TCP Server",
        loc_mode: "",
        interval: "",
        realtime_forward: "",
        listen_port: "",
        server: [""],
        loc_dev_id: "",
        username: "",
        password: "",
        topic_sub: "",
        topic_pub: "",
        mqtt_qos: "0",
        mqtt_cid: "",
        mqtt_alive: "",
        enable_hbt: "",
        hbt_interval: "",
        hbt_data: "",
        proto: "LOC NMEA",
        index: 0,
        sname: undefined,
      }
    },
    async modeConfirm() {
      const res = await updateConfig(this.deviceSn, this.deviceDid, [
        {
          section: "mode",
          config: "smartloc",
          action: 0,
          index: [0],
          server: "smartloc",
          options: {
            ...this.modeFormData,
            enabled: row.enabled ? '1' : '0',
          }
        }
      ])
      if (res.data.data.mess === 0) {
        this.$message({
          showClose: true,
          message: this.$t("lang.ConfigSetting.Successfulconfiguration"),
          type: "success"
        });
        this.$emit("updateData");
      } else {
        this.$message({
          showClose: true,
          message: this.$t("lang.ConfigSetting.Configurationerror"),
          type: "warning"
        });
        return;
      }
      this.modeDialog = false;
    },
    async connConfirm() {
      this.connLoading = true;
      if (this.connFormData.sname) {
        // 编辑
        let s = this.connFormData.server.filter(item => { return item !== "" })
        const resp = await updateConfig(this.deviceSn, this.deviceDid, [
          {
            section: "conn",
            config: "smartloc",
            action: 0,
            index: [this.connFormData.index],
            server: "smartloc",
            options: {
              ...this.connFormData,
              sname: undefined,
              index: undefined,
              enabled: this.connFormData.enabled ? "1" : "0",
              server: undefined
            },
            lists: {
              server: s.length > 0 ? s : undefined
            }
          }
        ])
        if (resp.data.data.mess == 0) {
          this.$message.success('操作成功')
          this.connDialog = false
          this.$emit("updateData");
        } else {
          this.$message.error('操作失败')
        }
      } else {
        // 新增
        let s = this.connFormData.server.filter(item => { return item !== "" })
        const resp = await updateConfig(this.deviceSn, this.deviceDid, [
          {
            section: "conn",
            config: "smartloc",
            action: 1,
            index: [this.connData.length],
            server: "smartloc",
            options: {
              ...this.connFormData,
              sname: undefined,
              index: undefined,
              enabled: this.connFormData.enabled ? "1" : "0",
              server: undefined
            },
            lists: {
              server: s.length > 0 ? s : undefined
            }
          }
        ])
        if (resp.data.data.mess == 0) {
          this.$message.success('操作成功')
          this.connDialog = false
          this.$emit("updateData");
        } else {
          this.$message.error('操作失败')
        }
      }
      this.connLoading = false
    },
    connEdit(row) {
      this.connDialog = true;
      this.connFormData = {
        enabled: row.enabled == '1',
        name: row.name,
        mode: row.mode,
        loc_mode: row.loc_mode,
        interval: row.interval,
        realtime_forward: row.realtime_forward,
        listen_port: row.listen_port,
        server: (row.server.length === 0) ? [''] : row.server,
        loc_dev_id: row.loc_dev_id,
        username: row.username,
        password: row.password,
        topic_sub: row.topic_sub,
        topic_pub: row.topic_pub,
        mqtt_qos: row.mqtt_qos,
        mqtt_cid: row.mqtt_cid,
        mqtt_alive: row.mqtt_alive,
        enable_hbt: row.enable_hbt,
        hbt_interval: row.hbt_interval,
        hbt_data: row.hbt_data,
        proto: row.proto,
        index: row.index,
        sname: row.sname,
      }
    },
    addConn() {
      this.connDialog = true
    },
    async deleteConn(row) {
      const resp = await updateConfig(this.deviceSn, this.deviceDid, [
        {
          section: "conn",
          config: "smartloc",
          action: 2,
          index: [row.index],
          server: "smartloc",
        }
      ])
      if (resp.data.data.mess == 0) {
        this.$message.success('操作成功');
        this.connDialog = false;
        this.$emit("updateData");
      } else {
        this.$message.error('操作失败')
      }
    },
    updateCom() {
      updateConfig(this.deviceSn, this.deviceDid, [
        {
          section: "COM1",
          config: "smartloc",
          action: 0,
          index: [this.comForm.index],
          options: {
            ...this.comForm,
            index: undefined,
          },
        },

      ]).then(res => {
        if (res.data.data.mess === 0) {
          this.$message.success(this.$t('lang.ConfigSetting.successSetting'))
          this.$emit('updateData')
          this.comDialogVisible = false
        } else {
          this.$message.error(this.$t('lang.ConfigSetting.failSetting'))
        }
      })
    },
    editComDialog(com) {
      this.comDialogVisible = true
      this.comForm = com;
    },
    handleCloseComDialog() {
      this.comDialogVisible = false
      this.comForm = {
        section: '',
        baudrate: '',
        data_bits: '',
        stop_bits: '',
        parity: '',
        flow_ctrl: '',
        enable_frame: '',
        timeout: '',
        frame_len: '',
        index: '',
      }
    }
  },
  watch: {
    conn: {
      deep: true,
      handler(val) {
        this.modeDownlinkList = [];
        this.modeUplinkList = [];
        this.connData = val.map(item => {
          if (item.options.mode !== 'LOC Server') {
            this.modeDownlinkList.push({
              label: item.options.name,
              value: item.sname
            })
          }
          this.modeUplinkList.push({
            label: item.options.name,
            value: item.sname
          })
          return {
            ...item.options,
            conn: item.sname,
            index: item.index,
            sname: item.sname,
            server: item.lists.server,
            // uplink: item.lists.uplink,
            // downlink: item.lists.downlink
          }
        });
      }
    },
    mode: {
      deep: true,
      handler(val) {
        this.modeData = val.map(item => {
          return {
            ...item.options,
            uplink: item.lists.uplink,
            downlink: item.lists.downlink
          }
        })
      }
    },
    serial: {
      deep: true,
      handler(val) {
        this.comData = val.map(item => {
          return {
            ...item.options,
            interface: item.sname,
            index: item.index
          }
        })
      }
    }
  },
  components: {
    ListValue
  }
};
</script>
<style scoped>
.smartloc {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>